import { queryReferMetaData } from '@api';
import { observable } from 'mobx';



export class ReferStore {
  rootStore: any
  // 缓存数据存储
  referMetaDataMap: Map<string, any>
  constructor(_storeMeta: any, rootStore: any) {
    this.rootStore = rootStore;
    this.referMetaDataMap = observable.map()
  }

  /**
   * 缓存设置
   * @param referInfo 
   * @param data 
   */
  setMetaData(referInfo: any, data: object) {
    const { fullName, id, billNo } = referInfo
    const queryData = Array.isArray(data) ? data : [data]
    queryData.forEach((item: any) => {
      const referCacheKey = `${billNo}_${fullName}_${id}`
      const preMetaData = this.referMetaDataMap.get(referCacheKey)
      const newMetaData = item?.[fullName].find((i: any) => i?.id == id) || item?.[fullName][0]
      this.referMetaDataMap.set(referCacheKey, { ...preMetaData, ...newMetaData })
    })
  }

  /**
   * 缓存获取
   * @param referInfo 
   * @param fieldArr 
   * @returns 
   */
  getMetaData(referInfo: any, fieldArr?: Array<any>) {
    const { fullName, id, billNo } = referInfo
    const referCacheKey = `${billNo}_${fullName}_${id}`
    const cacheData = this.referMetaDataMap.get(referCacheKey) || {}
    if (fieldArr?.length) {
      return Object.fromEntries(Object.entries(cacheData).filter(([key, value]) => fieldArr.includes(key)));
    }
    return cacheData
  }
  
  /**
   * 元数据带入字段查询搜索
   * @param referInfo 
   * @param fieldArr 
   * @returns 
   */
  async getReferMetaData(id: string, metaFieldArr: Array<any>, fullName: string, refCode?: string) {
    const referInfo = {billNo: this.rootStore.pageStore.params.billNo, fullName, id}
    const cacheData = this.getMetaData(referInfo)
    const referMetaKeys = Object.keys(cacheData)
    const flag = metaFieldArr.every(itemA => referMetaKeys.includes(itemA));
    const fieldArr = this.getQueryData(id, metaFieldArr, fullName, refCode)?.fieldArr
    if (flag) {
      return this.getMetaData(referInfo, metaFieldArr)
    } else {
      try {
        const referMetaValue = await this.fetchReferMetaData(id, metaFieldArr, fullName, refCode)
        const returnValue = referMetaValue[0]?.[fullName]?.[0]
        const updateDataKeys = this.updateKeys(returnValue, fieldArr)
        this.setMetaData(referInfo, referMetaValue)
        return updateDataKeys
      } catch (error) {
        this.rootStore?.utils?.message?.danger(error?.message);
      }
    }
  }

  /**
   * 单个请求元数据
   * @param dataSourceAlias 
   * @returns 
   */
  fetchReferMetaData = async (id: string, metaFieldArr: Array<any>, fullName: string, refDomain?: string) => {
    const queryData = this.getQueryData(id, metaFieldArr, fullName, refDomain)
    const data = Array.isArray(queryData) ? queryData : [queryData]
    let params
    if (this.rootStore?.referInputProps?.domainKey) {
      params = { ...this.rootStore.pageStore.query, domainKey: this.rootStore?.referInputProps?.domainKey }
    } else {
      params = { ...this.rootStore.pageStore.query, domainKey: this.rootStore?.pageStore?.params?.domainKey }
    }
    const res = await queryReferMetaData({ params, data: {data} })
    return res.data
  }

  getQueryData(id: string, fieldMetaArr: Array<any>, fullName: string, refDomain?: string) {
    const ids = Array.isArray(id) ? id : [id]
    const fieldArr = Array.from(new Set(fieldMetaArr)).map((ele) => { return { field: ele, alias: ele.replace(/\./, '_') } })
    const domain = refDomain?.split('.')[0] || this.rootStore.pageStore.query.domainKey || this.rootStore.pageStore.params.domainKey
    return {fieldArr, ids, fullName, domain}
  }

  private updateKeys(data: any, fieldArr: Array<any>) {
    // 遍历fieldArr数组
    fieldArr.forEach(fieldObj => {
        let { field, alias } = fieldObj;
        // 如果原始数据中存在别名键
        if (data.hasOwnProperty(alias) && field !== alias) {
            // 更新原始数据对象的键名为field的值为别名键对应的值
            data[field] = data[alias];
            // 删除别名键
            delete data[alias];
        }
    });

    return data;
  }
}